import Vue from 'vue'

export default function addInterceptors (instance) {
  instance.interceptors.request.use(config => {
    // Set noshow to stop the app from showing a loading spinner
    // specifically for the sake of request comments that are currently polling, so we would have a spinner appear
    // without user input every n seconds (currently 10 seconds)
    if (!config.noshow) {
      Vue.bus.$emit('ajax-start', config)
    }
    return config
  }, error => {
    Vue.bus.$emit('ajax-stop')
    Vue.bus.$emit('show-notification', 'danger',  "Couldn't connect to server, please check your connection.")
    return Promise.reject(error)
  })

  instance.interceptors.response.use(response => {
    Vue.bus.$emit('ajax-stop')
    return response.data
  }, error => {
    if (error.response) {
      if (error.response.status == 401) {
        Vue.bus.$emit('invalid-token')
      }
      Vue.bus.$emit('show-notification', 'danger', error.response.data)
      Vue.bus.$emit('ajax-stop')
    } else {
      Vue.bus.$emit('ajax-stop')
      Vue.bus.$emit('show-notification', 'danger',  "Couldn't connect to server, please check your connection.")
    }
    return Promise.reject(error)
  })
}

